import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { UserRole } from '../../../utils/user-roles';
import { AuthService } from '../../../woo_services.module/AuthService';
import { TranslationService } from '../../../woo_services.module/TranslationService';
import { VoucherConditionDefinition, VoucherParams, VoucherService } from '../../../woo_services.module/VoucherService';
import { AdOrganisation, CompactAgency } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'new-voucher',
  templateUrl: './new-voucher.component.html',
  styles: [
    `
      .col-40percent {
        width: 40%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewVoucher {
  agencies = input<CompactAgency[]>();
  adOrganisations = input<AdOrganisation[]>();
  onNewVoucher = output<VoucherParams>();
  onAbort = output<void>();

  private translationService = inject(TranslationService);
  private authService = inject(AuthService);

  voucher: VoucherParams;
  conditions = signal<VoucherConditionDefinition[]>([]);
  convertVoucherConditions = this.translationService.convertVoucherConditions;
  convertDiscount = this.translationService.convertDiscount;

  readonly isAdminOrPlanner = this.authService.adminOrPlanner();
  readonly isAdminOrPlannerOrSales =
    this.isAdminOrPlanner || this.authService.hasAnyRole([UserRole.sales, UserRole.salesManager]);

  constructor(voucherService: VoucherService) {
    voucherService.getConditions().then((conditions: VoucherConditionDefinition[]) => {
      this.conditions.set(conditions);
      this.voucher.conditions = this.getVoucherConditions();
    });
    this.resetVoucherParams();
  }

  newVoucher = (): void => {
    if (this.adOrganisations().length > 0) {
      this.voucher.ad_organisation = { id: this.adOrganisations()?.find((org) => org.name === 'TV4').id };
    }
    this.voucher.conditions.forEach((condition) => {
      condition.values = [condition.values];
    });
    this.onNewVoucher.emit(Object.assign({}, this.voucher));
  };

  validDiscountAmount = (): boolean => {
    return this.voucher.discount > 0 && this.voucher.discount < 1;
  };

  private resetVoucherParams = () => {
    this.voucher = {
      discount: null,
      ad_organisation: null,
      agency: { id: null },
      conditions: this.getVoucherConditions(),
    };
  };

  private getVoucherConditions = () => this.conditions().map((condition) => ({ type: condition.type, values: null }));
}
